export default __webpack_public_path__ + "static/media/outdoor.efe89acb.png";